import Model from "../../utils/RestModel.js";
import Field from "../../utils/Field.js";
import App from "./App.js";
import Linguist from "../../../lib/JuiS/Linguist.js";
import DynamicField from "./DynamicField.js";
import TicketType from "./TicketType.js";
import {iconPickerFactory} from "../../components/fieldEditors/editorFactories.js";
import childTicketEditorLexicons from "./lexicons/child-ticket-editor/childTicketEditorLexicons.js";
import Ticket from "./Ticket.js";

const linguist = new Linguist(childTicketEditorLexicons);
export default new Model(function () {
    this.app = new Field(App);
    this.owningTicketType = new Field(TicketType);
    this.title = new Field().asTranslatableString();
    this.icon = new Field().asString().withLabel("Icon").withEditorFactory(iconPickerFactory);
    this.columns = new Field([DynamicField]).withOptionsLoader(DynamicField.getOptionsLoaderForModel(Ticket));
    this.ticketTypes = new Field([TicketType]);
    this.childType = new Field().asEnum(["PRIMARY", "SECONDARY"]);
    this.makeTranslatable();
    linguist.withAudience(this);
}, "ChildTicketEditor", "child-ticket-editors");
